<template>
    <MicroAppFaqPage />
</template>

<script setup lang="ts">
import MicroAppFaqPage from '~/components/micro-app/MicroAppFaqPage.vue'
</script>
